import { Stack, useEventCallback } from '@mui/material';
import {
  type ExtendedGridColumnHeaderProps,
  ExtendedAutocomplete,
  ContainerPopper,
  useMultipleSelectorProps,
  useDataGridContext,
  FakeDropdownBox,
} from '@issuemanager/apps/client/components';
import { useEffect, useMemo, useState } from 'react';
import {
  IssueActionProgressData,
  IssueActionProgressLabel,
  useIssueActionProgress,
} from '../issue-action-progress-label';

export function IssueGridActionProgressFilter(
  params: ExtendedGridColumnHeaderProps,
) {
  const options = useIssueActionProgress();
  const context = useDataGridContext();
  const value: IssueActionProgressData[] = useMemo(
    () => context.filterModel[params.field] ?? [],
    [context.filterModel, params.field],
  );

  const [partialValue, setPartialValue] = useState(value ?? []);

  const handleChange = useEventCallback((value) => {
    context.setFilterModel((prevState) => ({
      ...prevState,
      [params.field]: value,
    }));
  });

  const autocompleteProps = useMultipleSelectorProps({
    options,
    value,
    setValue: handleChange,
    partialValue,
    setPartialValue,
  });

  useEffect(() => {
    setPartialValue(value);
  }, [value]);

  return (
    <ContainerPopper
      renderTarget={(props) => (
        <FakeDropdownBox onClick={props.handleClick}>
          {value.length ? (
            <Stack direction='row' spacing={0.5}>
              {value.map((v) => (
                <IssueActionProgressLabel key={v.id} value={v.value} />
              ))}
            </Stack>
          ) : null}
        </FakeDropdownBox>
      )}
      renderChildren={(props) => (
        <ExtendedAutocomplete
          {...autocompleteProps}
          open
          options={options}
          getOptionLabel={(option) => option.label}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          renderOption={(_, option) => (
            <IssueActionProgressLabel value={option.value} />
          )}
          onClose={props.handleClose}
          TextFieldProps={{
            autoFocus: true,
          }}
        />
      )}
    />
  );
}
